import { Card, CardHeader } from '../../../components/Card.jsx'
import { Tile, BarList, MethodNote, fmtNum } from '../ui.jsx'

/**
 * National Geographic Insights — where the patient population (and
 * therefore the disease burden) is concentrated, by recorded place of
 * residence. Locations below the k=5 privacy floor are withheld.
 *
 * Province-level rollups will slot in here once residence is captured as
 * structured province data rather than free text.
 */
export default function GeographicInsights({ data }) {
  const geo = data.geographic || {}
  const byRes = geo.by_residence || []

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader
          title="Geographic insights"
          subtitle="Patient distribution by recorded place of residence — a proxy for where health resources are most needed."
          right={
            <span className="text-[10px] uppercase tracking-wide border rounded-full px-2 py-0.5 bg-sky-50 text-sky-700 border-sky-200">
              by residence
            </span>
          }
        />
        <MethodNote>
          Groups registered patients by recorded place of residence (free-text,
          case-normalised). Locations with fewer than 5 patients are hidden
          (k=5 floor).
        </MethodNote>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          <Tile label="Located patients" value={fmtNum(geo.located_patients)} colour="wantok" />
          <Tile label="Distinct locations" value={fmtNum(geo.distinct_locations)} colour="sky" />
          <Tile label="Shown (above floor)" value={fmtNum(byRes.length)} colour="slate" />
        </div>
      </Card>

      <Card>
        <CardHeader
          title="Top locations"
          subtitle="Registered patients per location, largest first. Locations with fewer than 5 patients are withheld."
        />
        <BarList items={byRes} colour="sky" />
      </Card>
    </div>
  )
}
